import { useContext, useEffect, useState } from 'react';
import { AuthContext } from 'context';
import { Description, Forum, ContentCopy } from '@mui/icons-material';
import { Box, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import Table from 'components/design-system/Table/Table';
import Text from 'components/design-system/Text/Text';
import { SimplePopper } from 'views/Transaccion/components';
import { ModalTransacciones } from '../ModalTransacciones';
import { PERMISOS } from 'const/Permisos';
import { AlertaError } from 'utils/Alertas';
import { useColumnTableEmpresa } from './hooks/useColumnTableEmpresa';
import serviceChat from 'services/chat';
import { DICTONARY } from 'const/Dictonary';
import { useLogicaNegocio } from './hooks/useLogicaNegocio';
import { useOcultaMuestraBotones } from './hooks/useOcultaMuestraBotones';

export const TablaTransacciones = ({
  listaTransacciones,
  pagination,
  setPagination,
  handleListaTransaccion,
  setData,
  setTotal,

  registroTablaSeleccionado,
  setRegistroTablaSeleccionado,
  setCoordinadasCentro,

  total,
  isLoading,
  filtros
}) => {
  const {
    perfiles: { isSuperAdmin, isAnalistaTerritorial, isOferente, isDemandante },
    logeduser,
    sucursalNoAdministrada,
    isTienePermisos
  } = useContext(AuthContext);

  // Data Login
  const { sucursales: sucursalesLogin } = logeduser;

  // HOOKS

  // COLUMNAS TABLA
  const empresaColumnTable = useColumnTableEmpresa();

  // LOGICA DE NEGOCIO
  const {
    // listaSucursalesUsuarioLogueado,
    listaSalasChat,
    setListaSalasChat,
    transaccionSelected,
    // setTransaccionSelected,
    dataEmpresasFiltradas,
    setDataEmpresasFiltradas,
    openModal,
    // setOpenModal,
    // handleOpenModal,
    handleCloseModal,
    handleClickTerminarYAprobarReceptor,
    handleClickTerminarYAprobarGenerador,
    handleClickTerminarYRechazar,
    handleClickResumenTransaccion,
    handleClickGuardarResiduoDeclarado,
    handleClickSalaChat,
    determinarRolEnTransaccion
  } = useLogicaNegocio();

  // MUESTRA O ESCONDE BOTONES
  const {
    handleMostrarBotonResumenTransaccion,
    muestraOcultaBotonCerrarTransaccion,
    muestraOcultaBotonGuardarResiduo
  } = useOcultaMuestraBotones();

  useEffect(() => {
    if (!logeduser) {
      return;
    }

    // OBTENER EL TIPO EMPRESA DEL USUARIO (DEMANDANTE/OFERENTE)
    try {
    } catch (err) {
      AlertaError(
        'Ha ocurrido un error al tratar de obtener el tipo de empresa del usuario.'
      );
      console.error(err);
    }

    let params = {
      numPagina: pagination.pageIndex,
      totalPagina: pagination.pageSize,
      ...filtros
    };
    if (isAnalistaTerritorial) {
      const codigoRegion =
        logeduser.region?.codigoRegion ??
        DICTONARY.DEFAULT_REGION.REGION_METROPOLITANA;
      params.codigoRegion = codigoRegion;
    }

    // Ejecuta servicio de transacciones
    handleListaTransaccion(params);

    // SALAS DE CHAT
    if (!isSuperAdmin) {
      // SUPERADMIN NO PUEDE VER LAS CONVERSACIONES
      try {
        serviceChat
          .salaChat(null, DICTONARY.INTERCEPTOR.DESACTIVADO)
          .then(result => {
            const { data } = result;
            const { content, empty } = data;
            if (empty) {
              setListaSalasChat([]);
              console.log('LISTA DE SALAS DE CHAT VACÍA!');
            } else if (Array.isArray(content)) {
              // console.log('Salas de chat >> ', content);
              setListaSalasChat(content);
            }
          })
          .catch(err => {
            AlertaError(
              'Ha ocurrido un error al tratar de obtener la lista de salas de reunión.'
            );
            console.error(err);
          });
      } catch (err) {
        AlertaError(
          'Ha ocurrido un error al tratar de obtener la lista de salas de reunión.'
        );
        console.error(err);
      }
    }
  }, [
    pagination.pageIndex,
    pagination.pageSize,
    handleListaTransaccion,
    isSuperAdmin,
    setData,
    setTotal,
    sucursalNoAdministrada,
    filtros
  ]);

  // // SOLO PARA RECEPTORES   - DEMANDANTES(deprecado)
  const transaccionConSalaChat = codigoTransaccion => {
    if (!codigoTransaccion) return;
    if (!listaSalasChat) return;

    let salaChat = listaSalasChat.find(
      sala => sala.transaccion?.codigoTransaccion === codigoTransaccion
    );

    if (salaChat) {
      return true;
    }

    return false;
  };

  const calcularCentro = arrMarkers => {
    const totalMarkers = arrMarkers.length;
    if (totalMarkers === 0) return [0, 0];

    let totalLat = 0;
    let totalLon = 0;

    arrMarkers.forEach(marker => {
      totalLat += marker.latitud;
      totalLon += marker.longitud;
    });

    setCoordinadasCentro([totalLat / totalMarkers, totalLon / totalMarkers]);
  };

  const handleSeleccionarEmpresa = empresa => {
    if (empresa !== registroTablaSeleccionado) {
      setRegistroTablaSeleccionado(empresa.codigoTransaccion);
      calcularCentro(
        listaTransacciones.dataMapa.filter(
          item => item.codigoTransaccion === empresa.codigoTransaccion
        )
      );
    }
  };

  useEffect(() => {
    setRowSelection({ row: -1 });
    setRegistroTablaSeleccionado(null);
    calcularCentro(listaTransacciones.dataMapa);
  }, [listaTransacciones]);

  const [rowSelection, setRowSelection] = useState([]);

  const obtenerMenuItems = row => {
    const opcionesMenu = [];
    // console.log('row.original >> ', row.original);
    // Demandante : Receptor y Oferente : Generador
    const {
      infoOferente: nombreGenerador,
      infoDemandante: nombreReceptor,
      ultimaTrasaccion
    } = row.original;

    // Determina si el generador y el receptor son la misma empresa
    const esDelMismoNegocio = nombreGenerador.nombre === nombreReceptor.nombre;

    // Mapeo de estados de transacción
    const estadosTransaccion = {
      [DICTONARY.ESTADOS_TRANSACCION[1].CODIGO]: 'iniciada',
      [DICTONARY.ESTADOS_TRANSACCION[2].CODIGO]: 'aprobadoPorReceptor',
      [DICTONARY.ESTADOS_TRANSACCION[3].CODIGO]: 'rechazadoPorReceptor',
      [DICTONARY.ESTADOS_TRANSACCION[4].CODIGO]: 'aprobadoPorGenerador',
      [DICTONARY.ESTADOS_TRANSACCION[5].CODIGO]: 'rechazadoPorGenerador',
      [DICTONARY.ESTADOS_TRANSACCION[6].CODIGO]: 'finalizadoRecepcionado',
      [DICTONARY.ESTADOS_TRANSACCION[7].CODIGO]: 'finalizadoNoRecepcionado'
    };

    // Obtener estado actual
    const estadoActual = estadosTransaccion[ultimaTrasaccion.codigoEstado];

    // Determinar estados
    let esAprobadoPorGenerador = false;
    let esAprobadoPorReceptor = false;
    let esRechazadoPorGenerador = false;
    let esRechazadoPorReceptor = false;
    let esFinalizadoRecepcionado = false;
    let esFinalizadoNoRecepcionado = false;

    switch (estadoActual) {
      case 'aprobadoPorGenerador':
        esAprobadoPorGenerador = true;
        break;
      case 'aprobadoPorReceptor':
        esAprobadoPorReceptor = true;
        break;
      case 'rechazadoPorGenerador':
        esRechazadoPorGenerador = true;
        break;
      case 'rechazadoPorReceptor':
        esRechazadoPorReceptor = true;
        break;
      case 'finalizadoRecepcionado':
        esFinalizadoRecepcionado = true;
        break;
      case 'finalizadoNoRecepcionado':
        esFinalizadoNoRecepcionado = true;
        break;

      default:
        break;
    }

    // Mostrar opciones
    const muestraOpcionGenerador = !(
      esAprobadoPorGenerador ||
      esRechazadoPorGenerador ||
      esFinalizadoRecepcionado ||
      esFinalizadoNoRecepcionado
    );

    const muestraOpcionReceptor = !(
      esAprobadoPorReceptor ||
      esRechazadoPorReceptor ||
      esFinalizadoRecepcionado ||
      esFinalizadoNoRecepcionado
    );

    if (
      (isOferente || isDemandante) &&
      isTienePermisos(PERMISOS.salasReunion)
    ) {
      opcionesMenu.push(
        <ListItemButton
          disabled={!transaccionConSalaChat(row.original.codigoTransaccion)}
          onClick={e => handleClickSalaChat(row.original.codigoTransaccion)}
        >
          <ListItemIcon className="min-w-[40px]">
            <Forum className="text-uv-primary-0" />
          </ListItemIcon>
          <ListItemText
            primary={
              <Text
                className="font-secondary text-uv-primary-0 tracking-wider"
                size="M"
              >
                Sala de reunión
              </Text>
            }
          />
        </ListItemButton>
      );
    }

    // Determina si son del mismo negocio o si tiene permisos de administración de sucursales pero tiene los permisos necesarios en las dos sucursales
    // logica : si es del mismo negocio  o si tiene permisos de administración de sucursales y tiene los permisos necesarios en las dos sucursales muestra los dos botones
    const { codigoTransaccion } = row.original;
    const transaccion = dataEmpresasFiltradas.find(
      t => t.codigoTransaccion === codigoTransaccion
    );
    const transaccionCoincidePermisos =
      codigoTransaccion === transaccion?.codigoTransaccion &&
      transaccion?.coincidePermisos;
    const tienePermisoAlMenosEnUnaEmpresa = transaccion?.alMenosUnaCoincide;

    const mostrarOpciones =
      esDelMismoNegocio ||
      (isTienePermisos(PERMISOS.administracionSucursales) &&
        transaccionCoincidePermisos);
    // (isTienePermisos(PERMISOS.administracionSucursales && tienePermisoAlMenosEnUnaEmpresa));
    if (
      muestraOcultaBotonCerrarTransaccion(
        row.original.codigoTransaccion,
        row.original.transaccionEstado,
        row.original,
        esDelMismoNegocio,
        transaccionCoincidePermisos
      ) &&
      isTienePermisos(PERMISOS.cerrarTransaccion)
    ) {
      opcionesMenu.push(
        // Si el generador y el receptor son la misma empresa o tiene permisos de administración de sucursales muestra los dos botones
        mostrarOpciones ? (
          <>
            {muestraOpcionGenerador && (
              <Box display="flex" alignItems="center">
                <SimplePopper
                  titulo={`Cerrar transacción ${DICTONARY.ROL.GENERADOR.NOMBRE}`}
                  transaccion={row.original}
                  handleClickTerminarYAprobar={
                    handleClickTerminarYAprobarGenerador
                  }
                  handleClickTerminarYRechazar={handleClickTerminarYRechazar}
                  rol={DICTONARY.ROL.GENERADOR.NOMBRE}
                />
              </Box>
            )}
            {muestraOpcionReceptor && (
              <>
                <Box display="flex" alignItems="center">
                  <SimplePopper
                    titulo={`Cerrar transacción ${DICTONARY.ROL.RECEPTOR.NOMBRE}`}
                    transaccion={row.original}
                    handleClickTerminarYAprobar={
                      handleClickTerminarYAprobarReceptor
                    }
                    handleClickTerminarYRechazar={handleClickTerminarYRechazar}
                    rol={DICTONARY.ROL.RECEPTOR.NOMBRE}
                  />
                </Box>
              </>
            )}
          </>
        ) : (
          // caso contrario solo muestra un botón de cerrar transacción según el rol
          <>
            <Box display="flex" alignItems="center">
              <SimplePopper
                titulo="Cerrar transacción"
                transaccion={row.original}
                handleClickTerminarYAprobar={
                  determinarRolEnTransaccion(row.original) ===
                  DICTONARY.ROL.RECEPTOR.NOMBRE
                    ? handleClickTerminarYAprobarReceptor
                    : handleClickTerminarYAprobarGenerador
                }
                rol={
                  determinarRolEnTransaccion(row.original) ===
                  DICTONARY.ROL.RECEPTOR.NOMBRE
                    ? DICTONARY.ROL.RECEPTOR.NOMBRE
                    : DICTONARY.ROL.GENERADOR.NOMBRE
                }
                handleClickTerminarYRechazar={handleClickTerminarYRechazar}
              />
            </Box>
          </>
        )
      );
    }

    if (isTienePermisos(PERMISOS.resumenTransaccion)) {
      opcionesMenu.push(
        <ListItemButton
          disabled={
            handleMostrarBotonResumenTransaccion(row.original) ||
            row.original.ultimaTrasaccion === 'Iniciada'
          }
          onClick={e =>
            handleClickResumenTransaccion(row.original.codigoTransaccion)
          }
        >
          <ListItemIcon className="min-w-[40px]">
            <Description className="text-uv-primary-0" />
          </ListItemIcon>
          <ListItemText
            primary={
              <Text
                className="font-secondary text-uv-primary-0 tracking-wider"
                size="M"
              >
                Resumen de transacción
              </Text>
            }
          />
        </ListItemButton>
      );
    }

    if (
      muestraOcultaBotonGuardarResiduo(
        row.original.codigoTransaccion,
        row.original.transaccionEstado
      ) &&
      isTienePermisos(PERMISOS.resumenTransaccion)
    ) {
      opcionesMenu.push(
        <ListItemButton
          className="max-w-xs"
          onClick={e =>
            handleClickGuardarResiduoDeclarado(row.original.codigoTransaccion)
          }
          disabled={row.original.residuoDeclarado}
        >
          <ListItemIcon className="min-w-[40px]">
            <ContentCopy className="text-uv-primary-0" />
          </ListItemIcon>
          <ListItemText
            primary={
              <Text
                className="font-secondary text-uv-primary-0 tracking-wider"
                size="M"
              >
                {row.original.residuoDeclarado
                  ? 'El registro ya fue guardado como residuo declarado'
                  : 'Guardar como residuo declarado'}
              </Text>
            }
          />
        </ListItemButton>
      );
    }

    return opcionesMenu;
  };

  useEffect(() => {
    // si es super admin o no hay sucursales no se filtra
    if (isSuperAdmin || sucursalesLogin.length === 0) return;
    const todasLasEmpresas = sucursalesLogin.map(
      sucursal => sucursal.sucursal.empresa
    );

    if (listaTransacciones?.dataTabla?.length) {
      const empresasPermitidasSet = new Set(
        todasLasEmpresas.map(emp => emp.codigoEmpresa)
      );

      const sucursalTransaccionFiltrada = listaTransacciones.dataTabla
        .map(lista => {
          try {
            return {
              codigoTransaccion: lista.codigoTransaccion,
              sucursal: (lista.sucursalTransaccion || []).map(sucursal => ({
                ...(sucursal.sucursal?.empresa || {}),
                tienePermiso: empresasPermitidasSet.has(
                  sucursal.sucursal?.empresa?.codigoEmpresa
                )
              })),
              coincidePermisos: lista.sucursalTransaccion.every(sucursal =>
                empresasPermitidasSet.has(
                  sucursal.sucursal.empresa?.codigoEmpresa
                )
              ),
              alMenosUnaCoincide:
                lista.sucursalTransaccion?.some(sucursal =>
                  empresasPermitidasSet.has(
                    sucursal.sucursal.empresa?.codigoEmpresa
                  )
                ) || false
            };
          } catch (error) {
            console.error('Error procesando transacción:', error);
            return null;
          }
        })
        .filter(Boolean);

      setDataEmpresasFiltradas(sucursalTransaccionFiltrada);
    } else {
      setDataEmpresasFiltradas([]);
    }

    // console.log('sucursales >> ', sucursales);
  }, [isSuperAdmin, listaTransacciones.dataTabla, sucursalesLogin]);

  return (
    <div className="col-span-12 lg:col-span-8">
      <Table
        muiTableContainerProps={{ sx: { height: '600px' } }}
        columns={empresaColumnTable}
        data={listaTransacciones.dataTabla}
        className="h-full"
        rowCount={total}
        isLoading={isLoading}
        manualPagination
        enableColumnActions={true}
        enableColumnFilters={false}
        enablePagination={true}
        enableTopToolbar={false}
        muiTableBodyCellProps={{
          sx: {
            verticalAlign: 'top'
          }
        }}
        getRowId={row => row.codigoTransaccion}
        muiTableBodyRowProps={({ row }) => ({
          onClick: ev => {
            if (ev.target.parentElement.nodeName === 'BUTTON') {
              //Desactiva el desmarcar al presionar un botón
              return;
            }
            if (row.id === rowSelection.id) {
              setRowSelection({ row: -1 });
              setRegistroTablaSeleccionado(null);
              return;
            }
            setRowSelection(row);
            handleSeleccionarEmpresa(row.original);
          },
          selected: rowSelection.id === row.id,
          sx: {
            cursor: 'pointer'
          }
        })}
        enableRowActions
        renderRowActionMenuItems={({ row }) => obtenerMenuItems(row)}
        displayColumnDefOptions={{
          'mrt-row-actions': {
            header: 'Acciones',
            size: 100
          }
        }}
        positionActionsColumn="last"
        onPaginationChange={setPagination}
        state={{
          isLoading,
          showProgressBars: false,
          pagination: pagination,
          columnVisibility: {
            nombreRegion: isSuperAdmin ? true : false
          }
        }}
      />

      <ModalTransacciones
        transaccionSelected={transaccionSelected}
        openModal={openModal}
        handleCloseModal={handleCloseModal}
      />
    </div>
  );
};
